import React, { useState } from 'react';
import { Button } from '../components/Button';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { CheckIcon, XIcon, StarIcon, QuoteIcon, PhoneForwardedIcon, MessageCircleIcon, CalendarCheckIcon, ZapIcon, WorkflowIcon, DatabaseIcon, BrainCircuitIcon, CheckCircleIcon, ShieldCheckIcon, ClockIcon, AwardIcon, PhoneIcon, BellIcon, ClipboardCheckIcon, SendIcon, ChevronDownIcon } from 'lucide-react';
function ProfessionalHeroLight() {
  return <section className="w-full bg-white py-20 md:py-32" data-id="element-2676">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-2677">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-2678">
          <div data-id="element-2679">
            <div className="inline-block bg-[#F1B530] text-white px-4 py-2 rounded-full font-['Inter'] font-bold text-sm mb-6 animate-[fadeInUp_0.8s_ease-out]" data-id="element-2680">
              TRUSTED BY 1000+ BUSINESSES
            </div>

            <h1 className="font-['Poppins'] font-bold text-5xl md:text-6xl lg:text-7xl text-[#1A1A1A] mb-6 leading-tight animate-[fadeInUp_0.8s_ease-out_0.2s] opacity-0 [animation-fill-mode:forwards]" data-id="element-2681">
              Professional AI Call Answering Service
            </h1>

            <p className="font-['Inter'] text-xl text-[#6B6B6B] mb-8 leading-relaxed font-light animate-[fadeInUp_0.8s_ease-out_0.4s] opacity-0 [animation-fill-mode:forwards]" data-id="element-2682">
              Never miss an important call again. Our AI receptionist answers
              24/7, captures every detail, and integrates seamlessly with your
              business operations.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8 animate-[fadeInUp_0.8s_ease-out_0.6s] opacity-0 [animation-fill-mode:forwards]" data-id="element-2683">
              <Button size="lg" data-id="element-2684">Get Started Free</Button>
              <Button variant="secondary" size="lg" theme="light" data-id="element-2685">
                Request Demo
              </Button>
            </div>

            <div className="flex items-center gap-6 text-sm text-[#6B6B6B] font-['Inter'] animate-[fadeInUp_0.8s_ease-out_0.8s] opacity-0 [animation-fill-mode:forwards]" data-id="element-2686">
              <div className="flex items-center gap-2" data-id="element-2687">
                <CheckIcon className="w-5 h-5 text-[#F1B530]" data-id="element-2688" />
                <span data-id="element-2689">No credit card required</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2690">
                <CheckIcon className="w-5 h-5 text-[#F1B530]" data-id="element-2691" />
                <span data-id="element-2692">7-day free trial</span>
              </div>
            </div>
          </div>

          <div className="relative animate-[fadeInUp_0.8s_ease-out_1s] opacity-0 [animation-fill-mode:forwards]" data-id="element-2693">
            <div className="bg-white border border-[#E5E5E5] rounded-3xl p-8 shadow-xl" data-id="element-2694">
              <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80" alt="Professional service" className="w-full h-96 object-cover rounded-2xl" data-id="element-2695" />
            </div>

            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white/95 backdrop-blur-md border border-[#F1B530]/30 rounded-2xl p-6 shadow-xl" data-id="element-2696">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-2697">
                99.9%
              </div>
              <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-2698">
                Call Answer Rate
              </div>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-2699">{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>;
}
function TrustBadgesLightAnimated() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const badges = [{
    icon: CheckCircleIcon,
    label: '99.9% Uptime',
    value: 'Guaranteed'
  }, {
    icon: ShieldCheckIcon,
    label: 'Enterprise Security',
    value: 'SOC 2 Certified'
  }, {
    icon: ClockIcon,
    label: '24/7 Support',
    value: 'Always Available'
  }, {
    icon: AwardIcon,
    label: '10,000+ Calls',
    value: 'Handled Daily'
  }];
  return <section className="w-full bg-white py-16 border-y border-[#E5E5E5]" data-id="element-2700">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2701">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-2702">
          {badges.map((badge, index) => {
          const Icon = badge.icon;
          return <div key={index} className="text-center" data-id="element-2703">
                <div className="w-16 h-16 bg-[#F1B530]/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-[#F1B530]/20" data-id="element-2704">
                  <Icon className="w-8 h-8 text-[#F1B530]" data-id="element-2705" />
                </div>
                <div className="font-['Poppins'] text-2xl font-bold text-[#1A1A1A] mb-1" data-id="element-2706">
                  {badge.label}
                </div>
                <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-2707">
                  {badge.value}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function ServiceBreakdownLight() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const services = [{
    title: 'Call Answering',
    description: 'Professional greeting and message capture for every caller',
    features: ['Custom greetings', 'Message transcription', 'Real-time notifications']
  }, {
    title: 'Appointment Booking',
    description: 'Automated scheduling integrated with your calendar',
    features: ['Calendar sync', 'Booking confirmations', 'Reminder notifications']
  }, {
    title: 'Lead Qualification',
    description: 'Intelligent screening and routing of potential customers',
    features: ['Custom questions', 'Lead scoring', 'CRM integration']
  }, {
    title: 'After Hours Support',
    description: '24/7 coverage when your team is unavailable',
    features: ['Always available', 'Urgent call routing', 'Emergency protocols']
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-2708">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2709">
        <div className="text-center mb-16" data-id="element-2710">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-2711">
            Complete Call Management
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light max-w-3xl mx-auto" data-id="element-2712">
            Everything you need to handle calls professionally and efficiently
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2713">
          {services.map((service, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-2714">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-4" data-id="element-2715">
                {service.title}
              </h3>
              <p className="font-['Inter'] text-[#6B6B6B] mb-6 leading-relaxed font-light" data-id="element-2716">
                {service.description}
              </p>
              <ul className="space-y-3" data-id="element-2717">
                {service.features.map((feature, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-2718">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] flex-shrink-0" data-id="element-2719" />
                    <span className="font-['Inter'] text-[#1A1A1A] text-sm" data-id="element-2720">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}
function ComparisonTableLight() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const features = ['Instant call pickup', 'Custom greeting', 'Message capture', 'Call recordings', 'Real-time notifications', 'Appointment booking', 'CRM integration', 'After hours coverage', 'Multi-language support'];
  return <section className="w-full bg-white py-28" data-id="element-2721">
      <div ref={ref} className={`max-w-5xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2722">
        <div className="text-center mb-16" data-id="element-2723">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-2724">
            Why Choose AI Over Traditional Services?
          </h2>
        </div>

        <div className="bg-white border border-[#E5E5E5] rounded-3xl overflow-hidden shadow-lg" data-id="element-2725">
          <div className="grid grid-cols-3 gap-px bg-[#E5E5E5]" data-id="element-2726">
            <div className="bg-white p-6" data-id="element-2727">
              <div className="font-['Inter'] font-semibold text-[#6B6B6B] text-sm" data-id="element-2728">
                FEATURE
              </div>
            </div>
            <div className="bg-white p-6 text-center" data-id="element-2729">
              <div className="font-['Inter'] font-bold text-[#F1B530] text-lg" data-id="element-2730">
                AI Service
              </div>
            </div>
            <div className="bg-white p-6 text-center" data-id="element-2731">
              <div className="font-['Inter'] font-semibold text-[#6B6B6B] text-sm" data-id="element-2732">
                Traditional
              </div>
            </div>
          </div>

          {features.map((feature, index) => <div key={index} className="grid grid-cols-3 gap-px bg-[#E5E5E5]" data-id="element-2733">
              <div className="bg-white p-6" data-id="element-2734">
                <div className="font-['Inter'] text-[#1A1A1A]" data-id="element-2735">{feature}</div>
              </div>
              <div className="bg-white p-6 flex justify-center" data-id="element-2736">
                <CheckIcon className="w-6 h-6 text-[#F1B530]" data-id="element-2737" />
              </div>
              <div className="bg-white p-6 flex justify-center" data-id="element-2738">
                {index < 6 ? <CheckIcon className="w-6 h-6 text-[#6B6B6B]" data-id="element-2739" /> : <XIcon className="w-6 h-6 text-[#D0D0D0]" data-id="element-2740" />}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function OfficeHQPricingLight() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const plans = [{
    name: 'Starter',
    price: 'AUD $99',
    period: '/month',
    description: 'Perfect for small businesses',
    features: ['50 calls per month', 'Basic call answering', 'Message capture', 'Email notifications', 'Standard support'],
    cta: 'Start Free Trial'
  }, {
    name: 'Professional',
    price: 'AUD $249',
    period: '/month',
    description: 'Most popular for growing teams',
    features: ['200 calls per month', 'Advanced call routing', 'Appointment booking', 'CRM integration', 'Priority support', 'Call analytics'],
    cta: 'Start Free Trial',
    isPopular: true
  }, {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'For large organizations',
    features: ['Unlimited calls', 'Dedicated account manager', 'Custom integrations', 'Advanced analytics', '24/7 premium support', 'SLA guarantee'],
    cta: 'Contact Sales'
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-2741">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2742">
        <div className="text-center mb-16" data-id="element-2743">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-2744">
            Simple, Transparent Pricing
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-2745">
            Choose the plan that fits your business needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2746">
          {plans.map((plan, index) => <div key={index} className={`bg-white rounded-2xl p-8 border transition-all duration-300 hover:-translate-y-1 relative shadow-sm hover:shadow-md ${plan.isPopular ? 'border-[#F1B530] shadow-[0_0_40px_rgba(241,181,48,0.15)]' : 'border-[#E5E5E5] hover:border-[#F1B530]/50'}`} data-id="element-2747">
              {plan.isPopular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F1B530] text-white px-4 py-1 rounded-full font-['Inter'] font-semibold text-sm" data-id="element-2748">
                  Most Popular
                </div>}

              <div className="mb-6" data-id="element-2749">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-2" data-id="element-2750">
                  {plan.name}
                </h3>
                <p className="font-['Inter'] text-sm text-[#6B6B6B] font-light" data-id="element-2751">
                  {plan.description}
                </p>
              </div>

              <div className="mb-8" data-id="element-2752">
                <span className="font-['Poppins'] font-bold text-5xl text-[#1A1A1A]" data-id="element-2753">
                  {plan.price}
                </span>
                <span className="font-['Inter'] text-[#6B6B6B] ml-1" data-id="element-2754">
                  {plan.period}
                </span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-2755">
                {plan.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-2756">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] flex-shrink-0 mt-0.5" data-id="element-2757" />
                    <span className="font-['Inter'] text-[#1A1A1A] text-sm font-light" data-id="element-2758">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <Button className="w-full" size="lg" data-id="element-2759">
                {plan.cta}
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}
function OfficeHQTestimonialsLight() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const testimonials = [{
    quote: 'The AI answering service has been a game-changer for our law firm. We never miss a potential client call, even after hours.',
    author: 'Michael Chen',
    role: 'Managing Partner, Chen & Associates',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    rating: 5
  }, {
    quote: 'Professional, reliable, and cost-effective. Our clients love the immediate response, and we love the detailed call summaries.',
    author: 'Sarah Johnson',
    role: 'Operations Director, MedCare Clinic',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    rating: 5
  }, {
    quote: 'Setup was incredibly easy, and the integration with our CRM was seamless. Best investment we made this year.',
    author: 'David Martinez',
    role: 'CEO, RealtyPro Group',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
    rating: 5
  }];
  return <section className="w-full bg-white py-28" data-id="element-2760">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2761">
        <div className="text-center mb-16" data-id="element-2762">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-2763">
            Trusted by Professionals
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-2764">
            See what our clients have to say
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2765">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/30 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-2766">
              <div className="flex gap-1 mb-6" data-id="element-2767">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F1B530] fill-current" data-id="element-2768" />)}
              </div>

              <QuoteIcon className="w-10 h-10 text-[#F1B530]/20 mb-4" data-id="element-2769" />

              <p className="font-['Inter'] text-[#1A1A1A] mb-8 leading-relaxed font-light" data-id="element-2770">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-2771">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-[#F1B530]/20" data-id="element-2772" />
                <div data-id="element-2773">
                  <div className="font-['Inter'] font-semibold text-[#1A1A1A]" data-id="element-2774">
                    {testimonial.author}
                  </div>
                  <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-2775">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function OfficeHQAddOnsLight() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const addOns = [{
    icon: PhoneForwardedIcon,
    name: 'Live Transfer',
    price: 'AUD $99',
    setup: 'one-time setup',
    features: ['Instant call escalation', 'Full caller context transfer', 'Smart routing rules']
  }, {
    icon: MessageCircleIcon,
    name: 'FAQ Handling',
    price: 'AUD $299',
    setup: 'one-time fee',
    features: ['Custom knowledge base', 'Brand-safe responses', 'Reduced call volume']
  }, {
    icon: CalendarCheckIcon,
    name: 'Appointment Booking',
    price: 'AUD $399',
    setup: 'one-time setup',
    features: ['Calendar sync', 'Automated confirmations', 'Reminder notifications']
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-2776">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2777">
        <div className="text-center mb-16" data-id="element-2778">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-2779">
            Enhance Your Service
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-3xl mx-auto font-light" data-id="element-2780">
            Add powerful features to customize your AI answering service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2781">
          {addOns.map((addOn, index) => {
          const Icon = addOn.icon;
          return <div key={index} className="bg-white rounded-2xl border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 p-8 shadow-sm hover:shadow-md" data-id="element-2782">
                <div className="w-14 h-14 bg-[#F1B530] rounded-xl flex items-center justify-center mb-6" data-id="element-2783">
                  <Icon className="w-7 h-7 text-white" data-id="element-2784" />
                </div>

                <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-2785">
                  {addOn.name}
                </h3>

                <div className="mb-6" data-id="element-2786">
                  <span className="font-['Poppins'] font-semibold text-2xl text-[#F1B530]" data-id="element-2787">
                    {addOn.price}
                  </span>
                  <span className="text-[#6B6B6B] font-['Inter'] text-sm ml-2" data-id="element-2788">
                    {addOn.setup}
                  </span>
                </div>

                <ul className="space-y-3" data-id="element-2789">
                  {addOn.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-2790">
                      <CheckIcon className="w-5 h-5 text-[#F1B530] flex-shrink-0 mt-0.5" data-id="element-2791" />
                      <span className="font-['Inter'] text-[#1A1A1A] text-sm font-light" data-id="element-2792">
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function OfficeHQAdvancedAutomationLight() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const capabilities = [{
    icon: WorkflowIcon,
    text: 'Intelligent lead routing'
  }, {
    icon: ZapIcon,
    text: 'Automated workflows'
  }, {
    icon: DatabaseIcon,
    text: 'Direct CRM sync'
  }, {
    icon: BrainCircuitIcon,
    text: 'Data collection'
  }];
  return <section className="w-full bg-white py-28" data-id="element-2793">
      <div ref={ref} className={`max-w-6xl mx-auto px-8 md:px-12 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2794">
        <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 text-[#1A1A1A]" data-id="element-2795">
          Enterprise Automation
        </h2>
        <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B] mb-10" data-id="element-2796">
          Advanced capabilities for high-volume operations
        </p>

        <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-4xl mx-auto mb-16 leading-relaxed font-light" data-id="element-2797">
          For businesses handling 500+ calls per month, unlock enterprise-grade
          features that transform your communication infrastructure.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-2798">
          {capabilities.map((capability, index) => {
          const Icon = capability.icon;
          return <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md h-full flex flex-col items-center justify-center min-h-[180px]" data-id="element-2799">
                <div className="w-12 h-12 rounded-xl bg-[#F1B530]/10 flex items-center justify-center mb-5" data-id="element-2800">
                  <Icon className="w-6 h-6 text-[#F1B530]" data-id="element-2801" />
                </div>
                <p className="font-['Inter'] text-[#1A1A1A] font-light text-center" data-id="element-2802">
                  {capability.text}
                </p>
              </div>;
        })}
        </div>

        <Button size="lg" data-id="element-2803">Contact Sales</Button>
      </div>
    </section>;
}
function HowItWorksLightAnimated() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const steps = [{
    number: '01',
    icon: PhoneIcon,
    title: 'Call Received',
    description: 'Your AI receptionist answers instantly with your custom greeting, creating a professional first impression.'
  }, {
    number: '02',
    icon: ClipboardCheckIcon,
    title: 'Information Captured',
    description: 'Caller details, message, and context are accurately recorded and transcribed in real-time.'
  }, {
    number: '03',
    icon: BellIcon,
    title: 'Instant Notification',
    description: 'You receive immediate alerts via SMS or email with complete call summary and next steps.'
  }, {
    number: '04',
    icon: SendIcon,
    title: 'Seamless Integration',
    description: 'Call data automatically syncs to your CRM, calendar, or workflow tools for immediate action.'
  }];
  return <section className="w-full bg-white py-28" data-id="element-2804">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2805">
        <div className="text-center mb-16" data-id="element-2806">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-2807">
            How It Works
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light max-w-3xl mx-auto" data-id="element-2808">
            From call to action in four simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2809">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative" data-id="element-2810">
                {/* Connector line */}
                {index < steps.length - 1 && <div className="hidden lg:block absolute top-16 left-[60%] w-[80%] h-px bg-gradient-to-r from-[#F1B530] to-transparent" data-id="element-2811"></div>}

                <div className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md h-full" data-id="element-2812">
                  <div className="font-['Poppins'] text-5xl font-bold text-[#F1B530]/20 mb-4" data-id="element-2813">
                    {step.number}
                  </div>

                  <div className="w-14 h-14 bg-[#F1B530]/10 rounded-xl flex items-center justify-center mb-6 border border-[#F1B530]/20" data-id="element-2814">
                    <Icon className="w-7 h-7 text-[#F1B530]" data-id="element-2815" />
                  </div>

                  <h3 className="font-['Poppins'] font-bold text-xl text-[#1A1A1A] mb-4" data-id="element-2816">
                    {step.title}
                  </h3>

                  <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light text-sm" data-id="element-2817">
                    {step.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function IndustrySpecificSolutionsLightAnimated() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const industries = [{
    name: 'Legal Services',
    description: 'HIPAA-compliant call handling for law firms',
    features: ['Client intake screening', 'Confidential message handling', 'Urgent matter escalation', 'Case management integration']
  }, {
    name: 'Healthcare',
    description: 'Secure patient communication solutions',
    features: ['Appointment scheduling', 'Patient information capture', 'Emergency call routing', 'HIPAA compliance']
  }, {
    name: 'Real Estate',
    description: 'Never miss a property inquiry',
    features: ['Property inquiry handling', 'Viewing appointment booking', 'Lead qualification', 'Tenant support']
  }, {
    name: 'Professional Services',
    description: 'Maintain professional image 24/7',
    features: ['Client screening', 'Consultation booking', 'Message prioritization', 'Multi-office support']
  }, {
    name: 'Home Services',
    description: 'Capture every service request',
    features: ['Job booking', 'Emergency call handling', 'Quote request capture', 'Service scheduling']
  }, {
    name: 'Financial Services',
    description: 'Secure and compliant communication',
    features: ['Client verification', 'Appointment scheduling', 'Compliance adherence', 'Secure messaging']
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-2818">
      <div ref={ref} className={`max-w-7xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2819">
        <div className="text-center mb-16" data-id="element-2820">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-2821">
            Industry-Specific Solutions
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light max-w-3xl mx-auto" data-id="element-2822">
            Tailored AI answering services for your industry's unique needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2823">
          {industries.map((industry, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-2824">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-2825">
                {industry.name}
              </h3>
              <p className="font-['Inter'] text-[#6B6B6B] mb-6 text-sm font-light" data-id="element-2826">
                {industry.description}
              </p>
              <ul className="space-y-3" data-id="element-2827">
                {industry.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-2828">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] flex-shrink-0 mt-0.5" data-id="element-2829" />
                    <span className="font-['Inter'] text-[#1A1A1A] text-sm font-light" data-id="element-2830">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}
function OfficeHQFAQLightAnimated() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the AI answering service work?',
    answer: 'Our AI receptionist answers calls 24/7 using your custom greeting and protocols. It captures caller information, handles FAQs, and can book appointments or transfer urgent calls. All interactions are recorded and you receive instant notifications with complete call summaries.'
  }, {
    question: 'Can I customize the greeting and responses?',
    answer: 'Absolutely. You have full control over your company greeting, call handling protocols, and FAQ responses. Our system learns your business terminology and can be trained to handle industry-specific questions while maintaining your brand voice.'
  }, {
    question: "What happens if the AI can't handle a call?",
    answer: "The AI can seamlessly transfer calls to your team with full context when needed. You define the escalation rules - whether it's for urgent matters, specific request types, or VIP callers. The transfer includes all captured information so your team has complete context."
  }, {
    question: 'How quickly can I get started?',
    answer: 'Most businesses are live within 24 hours. Setup involves configuring your greeting, setting up call routing rules, and integrating with your existing tools. Our team provides hands-on support throughout the process to ensure everything works perfectly.'
  }, {
    question: 'Is my data secure and compliant?',
    answer: 'Yes. We maintain SOC 2 Type II certification and are HIPAA compliant for healthcare clients. All call data is encrypted in transit and at rest. We never share your data with third parties and provide complete audit trails for compliance requirements.'
  }, {
    question: 'What integrations are available?',
    answer: 'We integrate with major CRMs (Salesforce, HubSpot, Zoho), calendar systems (Google Calendar, Outlook, Calendly), communication tools (Slack, Teams), and can connect to custom systems via API. Our team can help set up any integration you need.'
  }];
  return <section className="w-full bg-white py-28" data-id="element-2831">
      <div ref={ref} className={`max-w-4xl mx-auto px-8 md:px-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-2832">
        <div className="text-center mb-16" data-id="element-2833">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-2834">
            Frequently Asked Questions
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] font-light" data-id="element-2835">
            Everything you need to know about our AI answering service
          </p>
        </div>

        <div className="space-y-4" data-id="element-2836">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#F1B530]/50 shadow-sm hover:shadow-md" data-id="element-2837">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left" data-id="element-2838">
                <span className="font-['Inter'] font-semibold text-xl text-[#1A1A1A] pr-8" data-id="element-2839">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F1B530] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-2840" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-2841">
                <div className="px-8 pb-6" data-id="element-2842">
                  <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-2843">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-2844">
          <p className="font-['Inter'] text-[#6B6B6B] mb-6" data-id="element-2845">
            Still have questions? We're here to help.
          </p>
          <Button variant="secondary" theme="light" data-id="element-2846">
            Contact Support
          </Button>
        </div>
      </div>
    </section>;
}
export function OfficeHQInspiredLight() {
  return <div className="w-full min-h-screen bg-white" data-id="element-2847">
      <ProfessionalHeroLight data-id="element-2848" />
      <TrustBadgesLightAnimated data-id="element-2849" />
      <HowItWorksLightAnimated data-id="element-2850" />
      <ServiceBreakdownLight data-id="element-2851" />
      <IndustrySpecificSolutionsLightAnimated data-id="element-2852" />
      <ComparisonTableLight data-id="element-2853" />
      <OfficeHQPricingLight data-id="element-2854" />
      <OfficeHQTestimonialsLight data-id="element-2855" />
      <OfficeHQAddOnsLight data-id="element-2856" />
      <OfficeHQAdvancedAutomationLight data-id="element-2857" />
      <OfficeHQFAQLightAnimated data-id="element-2858" />
    </div>;
}